export default __webpack_public_path__ + "static/media/peehip.86fae91d.png";